import React, {useState} from "react";
import {Button, Container, Grid, Paper, Box, Typography, TextField, Link as LinkComponent} from '@mui/material';
import {useNavigate} from "react-router-dom";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {useTranslation} from 'react-i18next';
import {Link} from "react-router-dom";

import logo from '../../../logo.svg';
import userActions from '../../../store/user/actions';

import {selectUserName} from "../../../store/user/selectors";
import APP_URLs from "../../../consts/url";

//@ts-expect-error
const View = (props) => {
    const [login, setLogin] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const {t: tranlate, i18n: languageCtx} = useTranslation();
    const navigate = useNavigate();
    if (props.userName?.length) {
        navigate(APP_URLs.MAIN);
    }
    //@ts-expect-error
    const onSubmit = (event) => {
        if (event) {
            event.preventDefault()
        }
        //@TODO: validate fields
        props.signIn({username: login, password});
    }
    return (
    <Container>
        <Grid container sx={{minHeight: '100dvh'}} justifyContent="center" alignItems="center">
            <Grid>
                <Paper component="form" onSubmit={onSubmit} elevation={3}>
                    <Box sx={{
                        backgroundColor: 'secondary.main',
                        pb: 2
                    }}>
                        <Box 
                            component='img'
                            alt="lift"
                            src={logo}
                            sx={{mx: 'auto', display: 'block', maxWidth: 136, maxHeight: 100, objectFit: 'fill'}}
                        />
                        <Typography
                            component={'h1'}
                            sx={{
                                color: '#f9f2bb',
                                fontSize: '2rem',
                                textAlign: 'center',
                                marginTop: '-10px'
                            }}
                        >
                            Lift Learning
                        </Typography>
                    </Box>
                    <Box sx={{p: 2, py: 4, width: '320px'}}>
                        <TextField
                            type="text"
                            placeholder={tranlate('auth:loginFieldText')}
                            defaultValue={login}
                            onChange={e => setLogin(e.target.value)}
                            required
                            fullWidth
                            sx={{mb: 1}}
                        />
                        <TextField
                            type="password"
                            placeholder={tranlate('auth:passwordFieldText')}
                            defaultValue={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                            fullWidth
                            sx={{mb: 3}}
                        />
                        <Grid justifyContent="center" alignItems="center" container>
                            <Button onClick={onSubmit} variant="contained">{tranlate('auth:loginBtnText')}</Button>
                        </Grid>
                        {/* <Grid justifyContent="center" alignItems="center" container sx={{mb: 2}}>
                            <LinkComponent href="javascript:void(0)">{tranlate('auth:forgotPswd')}</LinkComponent>
                        </Grid>
                        <Grid justifyContent="center" alignItems="center" container sx={{mb: 2}}>
                            <LinkComponent component={Link} to={APP_URLs.SIGN_UP}>{tranlate('auth:createAccountBtn')}</LinkComponent>
                        </Grid> */}
                    </Box>
                </Paper>
            </Grid>
        </Grid>
       
    </Container>
    );
}

//@ts-ignore
const mapStateToProps = (state, ownProps: OwnProps = {}) => {
    return {
        userName: selectUserName(state),
    }
}

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    signIn: bindActionCreators(userActions.login, dispatch),
	// clearAuthErr: bindActionCreators(userActions.clearAuthErr, dispatch)
})


export default connect(mapStateToProps, dispatchProps)(View);